// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".QEEzqQUHqNGOV9XLN24w4A\\=\\={border-radius:.7rem;height:.3rem;overflow:hidden}.QEEzqQUHqNGOV9XLN24w4A\\=\\=._1HzV0iHGUbl26V\\+MsJw9dw\\=\\={border-radius:.6rem;width:.3rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": "QEEzqQUHqNGOV9XLN24w4A==",
	"vertical": "_1HzV0iHGUbl26V+MsJw9dw=="
};
module.exports = ___CSS_LOADER_EXPORT___;
